import { render, staticRenderFns } from "./BatchMaster.vue?vue&type=template&id=46be2ac9&scoped=true"
import script from "./BatchMaster.vue?vue&type=script&lang=js"
export * from "./BatchMaster.vue?vue&type=script&lang=js"
import style0 from "./BatchMaster.vue?vue&type=style&index=0&id=46be2ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46be2ac9",
  null
  
)

export default component.exports